// 巡检监控
import React, { useRef, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'
import { App, Layout, theme, Space, Button, Alert, Segmented, Popconfirm, Tag, Tooltip, Spin, Row, Col, Divider } from 'antd'
import { LoadingOutlined, CloseOutlined, InfoCircleFilled, VerticalAlignBottomOutlined, ExclamationCircleFilled, CloseCircleFilled, InfoCircleOutlined, BlockOutlined, PlusOutlined, MinusOutlined } from '@ant-design/icons';
import { Amap as RMap, Polyline, config as AmapReactConfig, Marker as AmapMarker, LabelsLayer as AmapLabelsLayer, Markers as AmapMarkers, BezierCurve, Scale, TileLayer } from '@amap/amap-react';
import { transformGCJ2WGS, transformWGSGCJ2, demoMap, distance, debounce } from "@/common/js/common.js" //引入公共方法
import dayjs from 'dayjs';
import { getWebSocketAddress, getM30AirportNumber, getAirLiveAddress, getAirportHealthInfoAPI, changeLensAPI, airportHealthInfoReadAPI, returnHome, getLinePointApi, getKmlLinePointApi } from '@/server/commandFlight.js'
import { pushFlowLiveAPI, flowLiveUpdateAPI } from '@/server/airportCamera'
import FlvVideo from '@/component/FlvVideo/index.js'
import Marquee from 'react-fast-marquee';
// import './index.less'

import warning from '@/common/img/video/warning.svg';
import airportWarning from '@/common/img/video/airportWarning.svg';
import map_jc from "@/common/img/command_flight/map_jc.svg" //机场
import map_dd from "@/common/img/command_flight/map_dd.svg" //到达点位
import map_uavJT from "@/common/img/command_flight/map_uavJT.svg" //无人机箭头
import dqszhd from "@/common/img/command_flight/dqszhd.svg" //当前到达航点
import yschdzp from "@/common/img/command_flight/yschdzp.svg" //已经上传的航点照片

import fhgd from "@/common/img/command_flight/head/fhgd.svg" //返航高度
import xy from "@/common/img/command_flight/head/xy.svg" //小雨
import zy from "@/common/img/command_flight/head/zy.svg" //中雨
import dy from "@/common/img/command_flight/head/dy.svg" //大雨
import fs from "@/common/img/command_flight/head/fs.svg" //风速
import wd from "@/common/img/command_flight/head/wd.svg" //温度
import sd from "@/common/img/command_flight/head/sd.svg" //湿度

import Ethernet from "@/common/img/command_flight/head/Ethernet.svg" //以太网
import cell0 from "@/common/img/command_flight/head/cell0.svg" //4G信号 [0,15)
import cell15 from "@/common/img/command_flight/head/cell15.svg" //4G信号 [15,35)
import cell35 from "@/common/img/command_flight/head/cell35.svg" //4G信号 [35,55)
import cell55 from "@/common/img/command_flight/head/cell55.svg" //4G信号 [55,75)
import cell75 from "@/common/img/command_flight/head/cell75.svg" //4G信号 [75,95)
import cell95 from "@/common/img/command_flight/head/cell95.svg" //4G信号 [95,100)

import dl0 from "@/common/img/command_flight/head/dl0.svg" //电量 [0,25)
import dl25 from "@/common/img/command_flight/head/dl25.svg" //电量 [25,50)
import dl50 from "@/common/img/command_flight/head/dl50.svg" //电量 [50,75)
import dl75 from "@/common/img/command_flight/head/dl75.svg" //电量 [75,100)
import dl100 from "@/common/img/command_flight/head/dl100.svg" //电量 100
import dl_charge from "@/common/img/command_flight/head/dl_charge.svg" //充电中

import sdr0 from "@/common/img/command_flight/head/sdr0.svg" //SDR信号  [0,15)   
import sdr15 from "@/common/img/command_flight/head/sdr15.svg" //SDR信号  [15,35)  
import sdr35 from "@/common/img/command_flight/head/sdr35.svg" //SDR信号  [35,55)  
import sdr55 from "@/common/img/command_flight/head/sdr55.svg" //SDR信号  [55,75)  
import sdr75 from "@/common/img/command_flight/head/sdr75.svg" //SDR信号  [75,95)  
import sdr95 from "@/common/img/command_flight/head/sdr95.svg" //SDR信号  [95,100)

import wifi0 from "@/common/img/command_flight/head/wifi0.svg" //WiFi信号  [0,30)
import wifi30 from "@/common/img/command_flight/head/wifi30.svg" //WiFi信号  [30,60)
import wifi60 from "@/common/img/command_flight/head/wifi60.svg" //WiFi信号  [60,90)
import wifi90 from "@/common/img/command_flight/head/wifi90.svg" //WiFi信号  [90,100)
import wifi_close from "@/common/img/command_flight/head/wifi_close.svg" //WiFi信号 关闭
import wifi_none from "@/common/img/command_flight/head/wifi_none.svg" //WiFi信号  没有网络

import t_wrj from "@/common/img/command_flight/head/t_wrj.svg" //已链接上无人机
import f_wrj from "@/common/img/command_flight/head/f_wrj.svg" //未链接上无人机

import t_jc from "@/common/img/command_flight/head/t_jc.svg" //地图上的机场

import uav_t_p from "@/common/img/command_flight/uav/uav_t_p.svg" //已链接上  状态 p
import uav_f_p from "@/common/img/command_flight/uav/uav_f_p.svg" //未链接上  状态 p
import uav_t_a from "@/common/img/command_flight/uav/uav_t_a.svg" //已链接上  状态 a
import uav_f_a from "@/common/img/command_flight/uav/uav_f_a.svg" //未链接上  状态 a
import uav_t_m from "@/common/img/command_flight/uav/uav_t_m.svg" //已链接上  状态 m
import uav_f_m from "@/common/img/command_flight/uav/uav_f_m.svg" //未链接上  状态 m
import uav_ms from "@/common/img/command_flight/uav/uav_ms.svg" // M/S
import uav_t_dl from "@/common/img/command_flight/uav/uav_t_dl.svg" // 无人机满电池电量
import uav_f_dl from "@/common/img/command_flight/uav/uav_f_dl.svg" // 无人机缺电池电量
import uav_xdqfdgd from "@/common/img/command_flight/uav/uav_xdqfdgd.svg" // 相对起飞高度
import uav_xdjcgd from "@/common/img/command_flight/uav/uav_xdjcgd.svg" // 距离机场距离

import uav_t_ssbz from "@/common/img/command_flight/uav/uav_t_ssbz.svg" //已链接上  上视规避
import uav_f_ssbz from "@/common/img/command_flight/uav/uav_f_ssbz.svg" //未链接上  上视规避

import uav_t_xsbz from "@/common/img/command_flight/uav/uav_t_xsbz.svg" //已链接上  下视规避
import uav_f_xsbz from "@/common/img/command_flight/uav/uav_f_xsbz.svg" //未链接上  下视规避
import uav_t_spbz from "@/common/img/command_flight/uav/uav_t_spbz.svg" //已链接上  水平规避
import uav_f_spbz from "@/common/img/command_flight/uav/uav_f_spbz.svg" //未链接上  水平规避

import rtk from "@/common/img/command_flight/uav/uav_info/rtk.svg" // rtk数量
import gps from "@/common/img/command_flight/uav/uav_info/gps.svg" // gps数量
import dj from "@/common/img/command_flight/uav/uav_info/dj.svg" // 东经
import bw from "@/common/img/command_flight/uav/uav_info/bw.svg" // 北纬
import xdqfgd from "@/common/img/command_flight/uav/uav_info/xdgd.svg" // 相对起飞高度
import hbgd from "@/common/img/command_flight/uav/uav_info/hbgd.svg" // 海拔高度 
import spsd from "@/common/img/command_flight/uav/uav_info/spsd.svg" // 水平速度
import czsd from "@/common/img/command_flight/uav/uav_info/czsd.svg" // 垂直速度
import jcjl from "@/common/img/command_flight/uav/uav_info/jcjl.svg" // 距离机场距离

// import './newGodMap.css'
const { Content } = Layout;
AmapReactConfig.key = '193db6af15a86cd8d48b102ab461b002';

function VideoPatrolMonitor (props) {
  const { message } = App.useApp();
  let dockId = props.dockId;//当前选择的机场
  const dockIdRef = useRef(props.dockId);//当前机场
  let videoTypes = props.videoTypes.map((item) => { return item.value });//视频类型

  const mapkeys = [
    '86d93748cf75968bb768bfb9ff4b19fc',
    '86d93748cf75968bb768bfb9ff4b19fc',
    '86d93748cf75968bb768bfb9ff4b19fc',
  ];//天地图key
  const [choose_map_key, setChooseMapKey] = useState();
  const navigate = useNavigate();//路由跳转
  const location = useLocation();//路由接受参数
  const {
    token: { colorBorderSecondary, colorText },
  } = theme.useToken(); //获取主题颜色

  const limitsAuthority = useRef()//权限

  const [divLeft, setDivLeft] = useState(0);//监听鼠标指针
  const [divTop, setDivTop] = useState(0);//监听鼠标指针
  const [floating, setFloating] = useState({//鼠标指向显示信息
    visible: false,//是否可见
    title: '',//航线名称
  });


  //  --------------------机场镜头节能  相关------------------------------  ↓

  const timer = useRef()//读秒计时器
  const timeNum = useRef(0)//计时容器


  const cycle = useRef(0)//鼠标未动 周期
  const [timeNumber, setTimeNumber] = useState(0)//鼠标多少秒未动了
  const openInfoRef = useRef(0)//打开直播节流提示
  const [openInfo, setOpenInfo] = useState(0)
  const hasMouseStopLive = useRef(false)//鼠标是否动了

  //  --------------------机场镜头节能  相关------------------------------  ↑



  //  --------------------机场健康状态  相关------------------------------  ↓

  const [warningMessage, setWarningMessage] = useState({
    isOpen: false,//打开消息集
    isRead: false,//是否已读
    mainMsg: {},//最主要的消息集
    UAVMsg: [],//无人机消息集
    airportMsg: [],//机场消息集
    ids: [],//所有信息的id集合
  })

  const msgInterval = useRef()

  const [lineList, setLineList] = useState([])//获取到的航线列表信息

  //  --------------------机场健康状态  相关------------------------------  ↑



  //  -------------------------------------------------- 直播相关 ↓
  const [loadingAll, setLoadingAll] = useState(true);//全局loading
  const updataInterval = useRef()// updata  计时器
  const [videoId, setVideoId] = useState('')//直播id
  const [typeList, setTypeList] = useState([]);//视频类型字典
  const [videoType, setVideoType] = useState('cam');//默认的直播类型 
  const [shotType, setShotType] = useState('wide');//默认的镜头类型 
  const liveUrl = useRef('')
  const [liveUrlState, setLiveUrlState] = useState('')//直播地址
  const [UAVLiveStreamStart, setUAVLiveStreamStart] = useState(false)//无人机直播是否启动（按照无人机状态来定）
  //  -------------------------------------------------- 直播相关 ↑


  const mapRef = useRef();

  const closeWs = useRef(false)//是否可以重启ws

  const ws = useRef(null);
  const [wsList, setWsList] = useState({//WebSocket 所需列表
    aircraftSn: '',
    dockSn: '',
  })

  const token = localStorage.getItem('dock_token');
  const [loading, setLoading] = useState(props.loading)//加载中···

  const [opacity, setOpacity] = useState(true);//切换图层

  const [mapParameters, setMapParameters] = useState({//地图基础参数
    mapZoomScale: 17,//地图缩放比例
    mapScale: 3875.8509003722434,//地图比例尺
    mapDefaultScale: 3875.8509003722434,//默认比例尺
    mapCenterPoint: [0, 0],//地图中心点
  })

  const [globalStatus, setGlobalStatus] = useState({//全局状态
    isLiveShow: false,//是否展示直播页面
    isPipeline: false,//当前是否存在一条管线
    isReturnFlight: false,//是否  返航
    isShowPopconfirm: false,//是否  点击返航
    isOpenSeeUAVInfo: false,//是否查看无人机的参数信息
    isOpenSeeAirportInfo: false,//是否查看机场的参数信息
    title: '',
  })

  const [pipelineAndPoint, setPipelineAndPoint] = useState({//管线及航点坐标
    pipeline: [],//管线坐标
    waypointCoordinates: [],//航点坐标
  })

  const [otherLine, setOtherLine] = useState([]); //其他管线

  const [airportCoordinate, setAirportCoordinate] = useState([0, 0])//机场坐标
  const [uavCoordinate, setUAVCoordinate] = useState([0, 0])//无人机坐标
  const [airportData, setAirportData] = useState({})//ws中  机场
  const [UAVData, setUAVData] = useState({})//ws中  无人机

  //鼠标移动事件
  document.onmousemove = function () {
    setDivTop(window.event.pageY);
    setDivLeft(window.event.pageX);
  }

  // 飞行器当前状态
  const status = ["待机", "起飞准备", "起飞准备完毕", "手动飞行", "自动起飞", "航线飞行", "全景拍照", "智能跟随", "ADS-B躲避", "自动返航", "自动降落", "强制降落", "三桨叶降落", "升级中", "未连接", "APAS", "虚拟摇杆状态", "指令飞行"]


  const dronestatus = ["无意义", "电池电量不足（返航、降落）", "电池电压不足（返航、降落）", "电压严重过低（返航、降落）", "遥控器按键请求（起飞、返航、降落）", "App 请求（起飞、返航、降落）", "遥控信号丢失（返航、降落、悬停）", "导航、SDK 等外部设备触发（起飞、返航、降落）", "进入机场限飞区（降落）", "虽然触发了返航但是因为距离 Home 点距离太近（降落）", "虽然触发了返航但是因为距离 Home 点距离太远（降落）", "执行航点任务时请求（起飞）", "返航阶段到达 Home 点上方后请求（降落）", "飞行器高度下降，距地面 0.7m（二段降落限低）时，继续下降导致（降落）", "App、SDK 等设备强制突破限低保护进行（降落）", "因为周围有航班经过而请求（返航、降落）", "因为高度控制失败请求（返航、降落）", "智能低电量返航后进入（降落）", "AP 控制飞行模式（手动飞行）", "硬件异常（返航、降落）", "防触地保护结束（降落）", "返航取消 (悬停)", "返航时遇到障碍物（降落）", "机场场景下大风触发（返航）"];// 无人机错误原因



  const getAirportNumberByToken = async () => {// 进入页面即刻获取状态信息  用以确定是否展示前端页面
    if (ws.current) {
      ws.current.close()
      ws.current = null
    }
    setLoading(true)

    let glo = globalStatus
    let pip = pipelineAndPoint
    let obj = {
      access_token: token,
      CompanyID: localStorage.getItem('dock_CompanyID'),
      dock_id: dockIdRef.current ? dockIdRef.current : ''
    }
    let num = Math.floor(Math.random() * 3)
    setChooseMapKey(num);
    let res = await getM30AirportNumber(obj);
    if (res.ret !== 200) {
      message.warning(res.msg || '系统出错啦，请稍后重试！');
      glo.title = res.msg
      setGlobalStatus({ ...glo })
      setTimeout(() => {
        setLoading(false)
      }, 1000);
      return
    }
    if (res?.data?.dock_info?.Rtype === 10 && res?.data?.dock_info?.InsID !== 0) { getRoutesPoint() }

    let map = mapParameters
    map.mapCenterPoint = [Number(res.data.dock_info.longitude) || 0, Number(res.data.dock_info.latitude) || 0]
    setMapParameters({ ...map })

    let wsL = wsList
    wsL.aircraftSn = res.data.dock_info.aircraftSn
    wsL.dockSn = res.data.dock_info.dockSn
    setWsList({ ...wsL })

    getWebSocket(res.data.dock_info.aircraftSn, res.data.dock_info.dockSn)
    // 管线   转84
    let RoutesPoints = []
    if (res?.data?.Routes_Points) {
      res.data.Routes_Points.forEach((res) => {
        let d = transformGCJ2WGS({ lat: res.latitude, lon: res.longitude });
        let arr = [Number(parseFloat(d.lon).toFixed(7)), Number(parseFloat(d.lat).toFixed(7))];
        RoutesPoints.push(arr)
      })
    }

    // 航点   转84
    let InsPoints = []
    if (res?.data?.Ins_Points) {
      res.data.Ins_Points.forEach((res) => {
        let d = transformGCJ2WGS({ lat: res.latitude, lon: res.longitude });
        let arr = [Number(parseFloat(d.lon).toFixed(7)), Number(parseFloat(d.lat).toFixed(7))];
        // let arr = [res.longitude, res.latitude]
        InsPoints.push(arr)
      })
    }

    let otherPoint = [];
    if (res?.data?.point_lines) {
      res.data.point_lines.forEach((res) => {
        let arr = res.point_lines.map((item) => {
          let d = [Number(item.lon_wgs84), Number(item.lat_wgs84)];
          return d
        })
        if (Number(res.pipe_type) === 1) {
          otherPoint.push(arr)
        }
        // let arr = [res.longitude, res.latitude]
      })
    }

    setOtherLine(otherPoint);

    pip.pipeline = RoutesPoints
    pip.waypointCoordinates = InsPoints
    setPipelineAndPoint({ ...pip })
    glo.isPipeline = true
    setGlobalStatus({ ...glo })
    liveAddress(videoType)

    if (JSON.parse(localStorage.getItem('dock_DefaultMapPoints'))) {
      showMap(JSON.parse(localStorage.getItem('dock_DefaultMapPoints')))
    } else {
      showMap(res.data.dock_info.latitude ? [Number(res.data.dock_info.latitude), Number(res.data.dock_info.longitude)] : undefined)
    }
  }

  //获取直播地址
  const liveAddress = async (type) => {
    setLoadingAll(true)
    let obj = {
      access_token: token,
      camera: type,
      dock_id: dockIdRef.current ? dockIdRef.current : '',//当前机场id
    }
    let res = await getAirLiveAddress(obj);
    if (res.ret !== 200) {
      setLoadingAll(false)
      return
    }
    setTimeout(() => {
      setLoadingAll(false)
      liveUrl.current = res.data?.flv || ''
      setLiveUrlState(res.data?.flv || '')
      setVideoId(res.data.video_id)
    }, 2000);
  }

  const objectsBecomeList = (data, list, name = null) => {//将多级objcet转换成单级objcet
    Object.keys(data).forEach(res => {
      if (typeof data[res] === 'object') {
        objectsBecomeList(data[res], list, res)
      } else {
        if (name) {
          let na = `${name}_${res}`
          list[na] = data[res]
        } else {
          list[res] = data[res]
        }
      }
    })
  }

  const getWebSocket = async (aircraftSn, dockSn) => { // 获取 webSocket  地址
    let obj = {}
    let UAVobj = {}
    let airTime = 1
    let uavTime = 1
    let airNum = airportCoordinate[0] === 0 ? 1 : 2
    let uavNum = uavCoordinate[0] === 0 ? 1 : 2
    let res = await getWebSocketAddress({ access_token: token, type: '1' })
    if (res.ret === 200) {
      ws.current = new WebSocket(res.data);

      ws.current.onopen = (msg) => {//链接开启
        console.log("链接成功", msg);
      };

      ws.current.onmessage = e => {// 成功获取数据
        try {
          setTimeout(() => {
            setLoading(false)
          }, 1000);
          let data = JSON.parse(e.data)
          // console.log('ws的数据', data.data);

          if (data.biz_code === 'dock_osd' && data.data.sn === dockSn) {//机场
            // console.log('机场数据：', data.data, data?.data?.host?.drone_charge_state?.capacity_percent, dayjs().format('YYYY-MM-DD HH:mm:ss'));

            airTime = dayjs().valueOf()
            objectsBecomeList(data.data.host, obj)
            // wireless_link_sdr_quality
            setAirportData({ ...obj, sn: data.data.sn })
            if (airNum === 1 && obj.longitude) {
              setAirportCoordinate([Number(obj.longitude) || 0, Number(obj.latitude) || 0])
              airNum += 1
            }
          }

          if (data.biz_code === 'device_osd' && data.data.sn === aircraftSn) {//无人机
            closeWs.current = true
            // console.log('无人机数据：', data.data, dayjs().format('YYYY-MM-DD HH:mm:ss'));
            uavTime = dayjs().valueOf()
            objectsBecomeList(data.data.host, UAVobj)
            setUAVData({ ...UAVobj, sn: data.data.sn })

            if (uavNum === 1 && UAVobj.longitude) {
              setUAVCoordinate([Number(UAVobj.longitude) || 0, Number(UAVobj.latitude) || 0])
              uavNum += 1
            }
          }

        } catch (error) {
          // message.warning('当前机场状态错误，请确认机场是否正确链接')
        }
      }

      ws.current.onerror = (msg) => {//报错信息
        // console.log('链接出错', msg)
        closeWs.current = false
        message.warning('当前ws链接网络不佳，请稍后再试···')
      }
      //链接断开
      ws.current.onclose = (msg) => {
        airNum = 1
        setAirportData({})
        setUAVData({})
        clearInterval(settime)
      }

      // 6秒一次检查当前ws传回来的数据是否还在
      let settime = setInterval(() => {
        let airTimes = Math.abs(Math.floor(dayjs().valueOf() - airTime) / 1000)
        let uavTimes = Math.abs(Math.floor(dayjs().valueOf() - uavTime) / 1000)
        if (airTimes > 6) {
          setAirportData({})
          if (closeWs.current && ws.current) {
            ws.current.close()
            ws.current = null
            getAirportNumberByToken()
          }
        }
        if (uavTimes > 6) { setUAVData({}) }
      }, 5000);
    } else {
      message.warning(res.msg || '系统出错啦，请稍后重试！')
    }
  }

  const getAirporintInfo = async () => { //获取机场健康状态
    let war = warningMessage
    let res = await getAirportHealthInfoAPI({ access_token: token, dock_id: dockIdRef.current })
    if (res.ret !== 200) {
      message.warning(res.msg || '系统出错啦，请稍后重试！');
      return
    }
    let ids = []
    war.UAVMsg = res.data?.aircraftHms || []
    war.airportMsg = res.data?.dockHms || []
    war.mainMsg = res.data?.mainmsg || {}

    // war.isRead = res.data?.aircraftHms.length > 0 || res.data?.dockHms.length > 0
    res.data?.aircraftHms.forEach((res) => {
      ids.push(res.id)
    })
    res.data?.dockHms.forEach((res) => {
      ids.push(res.id)
    })
    war.ids = ids
    setWarningMessage({ ...war })
  }

  const getRoutesPoint = async () => {//获取航线信息
    let res = await getLinePointApi({ access_token: token, type: '1,7,10' })
    if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了'); return }

    let arr = []
    if (res.data.length > 0) {
      res.data.forEach((res, index) => {
        let obj = {
          ...res,
          id: res.r_id || res.id,//r_id 为 标识桩   id为 管线
          fileType: 1,//文件类型   1：excel   2:kml
          points: editPipePoint(res.point_lines, 1),
        }
        arr.push(obj)
      })
    }
    getKmlRoutesPoint(arr)
  }

  const getKmlRoutesPoint = async (list) => {//获取KML文件的航线信息
    let res = await getKmlLinePointApi({ access_token: token })
    if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了'); return }
    if (res.data.length > 0) {
      res.data.forEach((res, index) => {
        let obj = {
          ...res,
          fileType: 2,//文件类型   1：excel   2:kml
          points: editPipePoint(res.point_lines, 2),
        }
        list.push(obj)
      })
    }
    list.sort((a, b) => { return b.id - a.id })//将数据通过id进行倒叙
    setLineList([...list])
  }

  const editPipePoint = (data, fileType) => { //编辑 管线数据及标识桩数据
    if (data && data.length > 0) {
      if (fileType === 1) {
        return data.map((res, index) => {
          return [Number(res.lat_wgs84), Number(res.lon_wgs84)]
        })
      }
      if (fileType === 2) {
        let mainArr = []
        data.forEach((res) => {
          let arr = []
          res.forEach((ele, idx) => {
            arr.push([Number(ele.lat_wgs84), Number(ele.lon_wgs84)])
          })
          mainArr.push(arr)
        })
        return mainArr
      }
      return []
    } else {
      return []
    }
  }

  // 直播组件回调
  const returnData = debounce((data) => {
    if (data.canPushFlow) {
      // let aaa = 'https://media.w3.org/2010/05/sintel/trailer.mp4'
      pushFlow()
    }

    if (!data.isLeave && data.isLivePlay) {//判断直播已经开启
      cycle.current = 0
      updataLive()
    } else {
      clearInterval(timer.current)
      timer.current = null
    }

    if (data.isRefresh) { liveAddress(videoType) }//点击刷新，重新请求
  }, 2000)


  const timingAlgorithm = () => {//计算  计时算法
    timeNum.current = 0
    hasMouseStopLive.current = false

    clearInterval(timer.current)
    timeNum.current = null
    timer.current = setInterval(() => {
      timeNum.current += 1
      let aaa = cycle.current
      let bbb = timeNum.current
      if (hasMouseStopLive.current) {
        openInfoRef.current = 0
        setOpenInfo(0)
        if (timeNum.current === 20) { updataLive() }
      } else {
        if (timeNum.current >= 20) {//计算多少秒为一个周期
          cycle.current += 1
          timingAlgorithm()
        }

        if (cycle.current === 13) {//计算几个周期 弹出警示框
          openInfoRef.current = hasMouseStopLive.current ? 0 : 1
          setOpenInfo(openInfoRef.current)
          setTimeNumber(timeNum.current)
        } else {
          openInfoRef.current = 0
          setOpenInfo(0)
        }

        if (cycle.current > 13) {
          openInfoRef.current = 2
          setOpenInfo(2)
          setLiveUrlState('')
          return
        }//退出循环
      }
    }, 1000)
  }

  const handleMouseMove = debounce((event) => {// 定义处理鼠标移动的函数
    hasMouseStopLive.current = true
    openInfoRef.current = 0
    setOpenInfo(0)
    // 在这里执行你想要的操作，比如更新状态或调用函数
  }, 500)

  useEffect(() => {//监听 页面中是否移动鼠标
    // 添加鼠标移动监听器
    window.addEventListener('mousemove', handleMouseMove);

    // 组件卸载时，移除监听器
    return () => {
      clearInterval(timer.current)
      timer.current = null
      window.removeEventListener('mousemove', handleMouseMove);
    };

    // eslint-disable-next-line
  }, []); // 空依赖数组表示这个effect只在组件挂载和卸载时运行


  const updataLive = async () => {//更新直播
    let res = await flowLiveUpdateAPI({
      access_token: token,
      video_id: videoId
    })
    if (res.ret !== 200) { message.warning(res.msg || '更新失败'); return }
    cycle.current = 0
    hasMouseStopLive.current = false
    if (videoType === 'dock') { timingAlgorithm() }
  }

  // 直播推流
  const pushFlow = async () => {
    liveUrl.current = ''
    setLiveUrlState('')
    setLoadingAll(true)
    let obj = {
      access_token: token,
      camera: videoType,
      videoQuality: 0,
      dock_id: dockIdRef.current,//当前机场id
    }
    let res = await pushFlowLiveAPI(obj)
    if (res.ret !== 200) { message.warning(res.msg || '推流失败'); setLoadingAll(false); return }
    setTimeout(() => {
      setLoadingAll(false);
      liveUrl.current = res.data?.flv
      setLiveUrlState(res.data?.flv)
      // setLiveUrlState('https://media.w3.org/2010/05/sintel/trailer.mp4')
      setVideoId(res.data.video_id)
    }, 2000);
  }

  useEffect(() => {//监听 机场情况
    if (!warningMessage.isRead) {
      msgInterval.current = setInterval(() => {
        getAirporintInfo()
      }, 10000);
    } else {
      clearInterval(msgInterval.current)
      msgInterval.current = null
    }

    return () => {
      // 获取消息集
      clearInterval(msgInterval.current)
      msgInterval.current = null
    }
    // eslint-disable-next-line
  }, [warningMessage.isRead])

  useEffect(() => {
    limitsAuthority.current = JSON.parse(localStorage.getItem('dock_AirportPermissionsArr'));
    if (videoTypes.length > 0) {
      let list = [
        { value: 'dock', label: '机场', idx: 1 },
        { value: 'fpv', label: 'FPV', idx: 2 },
        { value: 'cam', label: '镜头', idx: 3 },
      ];
      let arr = [];
      for (let i = 0; i < list.length; i++) {
        if (videoTypes.indexOf(list[i].idx) >= 0) {
          arr.push(list[i]);
        }
      }
      setTypeList(arr);
    }

    return () => {
      if (ws.current) {//如果websoket存在  在切换页面时将其关闭
        closeWs.current = false
        ws.current.close()
        ws.current = null
      }
      if (document.getElementById('J_prismPlayer')) { document.getElementById('J_prismPlayer').remove() }
      if (document.getElementById('Fplayer'.innerHTML)) { document.getElementById('Fplayer'.innerHTML).remove() }

    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {// 监听机场id
    if (props.dockId) {
      dockIdRef.current = props.dockId;
      getAirporintInfo()
      getAirportNumberByToken();
    }
    // eslint-disable-next-line
  }, [props.dockId])


  useEffect(() => {  // 无人机状态
    if ((UAVData?.mode_code || UAVData?.mode_code === 0) && UAVData?.mode_code !== 14) { setUAVLiveStreamStart(true) } else { setUAVLiveStreamStart(false) }

    if (UAVData.mode_code === 1) {//待机
      let glo = globalStatus
      glo.isReturnFlight = false
      setGlobalStatus({ ...glo })
    }

    return () => {
      setUAVLiveStreamStart(false)
    }


    // eslint-disable-next-line
  }, [UAVData.mode_code])

  useEffect(() => {// 地图比例尺
    let num = Math.floor(Math.random() * 3)
    setChooseMapKey(num);
    // eslint-disable-next-line
  }, [mapParameters.mapScale])


  // -----------------------------------------本地化-------------------------------------------------------------

  const showMap = (centerPoint) => {//展示地图并标注机场
    // BM.Config.HTTP_URL = 'http://www.bigemap.com:9000';
    // mapRef.current = BM.map('map', 'bigemap.zhongkexingtu', { center: centerPoint, zoom: 17, zoomControl: false, attributionControl: false, bigemapLogo: false, });

    mapRef.current = demoMap(centerPoint)
  }

  useEffect(() => { //监听机场 获取数据
    // 机场位置
    if (airportData?.longitude && airportData?.longitude > 0) {
      let dockIcon = BM.icon({
        iconUrl: map_jc,
        iconSize: [18, 18],
        iconAnchor: [9, 9],//[左右，上下]
        popupAnchor: [0, 0],
        shadowUrl: 'my-icon-shadow.png',
        shadowSize: [0, 0],
        shadowAnchor: [0, 0],
      });
      BM.marker([Number(airportData?.latitude || 0), Number(airportData?.longitude || 0)], { draggable: false, icon: dockIcon, title: '机场', }).addTo(mapRef.current)
    }
  }, [airportData])



  useEffect(() => {//所有管线 及其 标识桩
    if (lineList.length > 0) {
      lineList.forEach((res, index) => {
        if (res.pipe_type === 1) {//管线
          BM.polyline(res.points, { color: '#FFBD0A', }).addTo(mapRef.current)
        }

        if (res.pipe_type === 3 && res.point_lines.length > 0) {//标识桩
          res.point_lines.forEach(ele => {
            let stakeIcon = BM.divIcon({
              className: '',
              iconAnchor: [0, 0],//[左右，上下]
              zIndexOffset: -1000,
              html: `
                <div>
                <img class="shadow pos_abs " src="data:image/png;base64,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" alt="标识桩" style="top: -93px; left: -14px;"/>
                <div class="pegpoint pos_abs  h17 w78 flex jcc align_center" style="top: -58px; left: -38px; color: rgb(0, 0, 0);">${ele.pt_name}</div></div>
                `
            });
            BM.marker([ele.lat_wgs84, ele.lon_wgs84], { draggable: false, icon: stakeIcon, title: res.pt_name, zIndex: 1 }).addTo(mapRef.current)
          })
        }
      })
    }
  }, [lineList])

  useEffect(() => {//航点坐标
    if (pipelineAndPoint.waypointCoordinates.length > 0) {
      pipelineAndPoint.waypointCoordinates.forEach((res, index) => {
        let linePointIcon = BM.divIcon({
          className: '',
          iconAnchor: [15, 10],//[左右，上下]
          zIndexOffset: -1000,
          html: `
          <div
          class='w30 h20 border flex jcc align_center radius4'
          style='background-color:#FFBD0A'>
          <span class='fs12 fw600 lh18' style='color:#000'>${index + 1}</span>
        </div>
            `
        });

        BM.marker([res[1], res[0]], { draggable: false, icon: linePointIcon, title: '航点' })
          .addTo(mapRef.current)
      })
    }

    if (pipelineAndPoint.pipeline.length > 0) {
      BM.polyline(pipelineAndPoint.pipeline.map((res) => { return [res[1], res[0]] }), { color: '#FFBD0A', }).addTo(mapRef.current)
    }



  }, [pipelineAndPoint])

  const marker_UAVPointRef = useRef()//无人机箭头 实例
  useEffect(() => {
    if (marker_UAVPointRef.current) {
      marker_UAVPointRef.current.remove()
      marker_UAVPointRef.current = null
    }
    if (UAVData.longitude) {
      let UAVIcon = BM.icon({
        iconUrl: map_uavJT,
        iconSize: [24, 24],
        iconAnchor: [12, 12],//[左右，上下]
        popupAnchor: [0, 0],
        shadowUrl: 'my-icon-shadow.png',
        shadowSize: [0, 0],
        shadowAnchor: [0, 0],
      });
      marker_UAVPointRef.current = BM.marker([UAVData.latitude, UAVData.longitude], { draggable: false, icon: UAVIcon, title: '无人机', rotationAngle: UAVData?.attitude_head, })
        .setZIndexOffset(950)
        .addTo(mapRef.current)
    }

    // eslint-disable-next-line
  }, [UAVData.latitude])


  // -----------------------------------------本地化-------------------------------------------------------------

  return (
    <>
      <div id='map' className='hei100' />

      {/* <div className='pos_rel hei100'> */}

      {/* 头部状态栏  */}
      <>
        {
          // JSON.stringify(airportData) !== '{}' &&
          <div
            className='pos_abs h40 wid100 pdRL16'
            style={{ top: 0, background: 'linear-gradient(to bottom, rgba(0,0,0,0.6),rgba(0,0,0,0))' }}
          >
            <div className='flex jcsb align_center hei100'>
              {/* left */}
              <div className='flex jcc align_center'>
                {/* 返航高度 */}
                <span className='flex jcc align_center marR12'>
                  <img draggable='false' alt='返航高度' src={fhgd} />
                  <span style={{ color: colorText }}>{Number(UAVData?.rth_altitude || 0).toFixed(1)}m</span>
                </span>

                {/* 雨天 */}
                <span>
                  <img
                    // rainfall :0无雨|1小雨|2中雨|3大雨
                    style={{
                      display: airportData?.rainfall > 0 && airportData?.rainfall < 65535 ? `` : `none`
                    }}
                    draggable='false'
                    alt='天气'
                    src={
                      airportData?.rainfall === 1
                        ? xy
                        : airportData?.rainfall === 2
                          ? zy
                          : dy
                    }
                  />
                </span>

                {/* 风速 */}
                <span className='flex jcc align_center marR12'>
                  <img draggable='false' alt='风速' src={fs} />
                  <span style={{ color: colorText }}>{airportData?.wind_speed}m/s</span>
                </span>

                {/* 温度 */}
                <span className='flex jcc align_center marR12'>
                  <img draggable='false' alt='温度' src={wd} />
                  <span style={{ color: colorText }}>{airportData?.environment_temperature}℃</span>
                </span>

                {/* 湿度 */}
                <span className='flex jcc align_center marR12'>
                  <img draggable='false' alt='湿度' src={sd} />
                  <span style={{ color: colorText }}>{airportData?.humidity}</span>
                </span>
              </div>

              {/* 问题提示框 */}
              {
                JSON.stringify(warningMessage.mainMsg) !== '{}' &&
                <div className='w280'>
                  <Alert
                    type={warningMessage.mainMsg?.level === 0 ? `success` : warningMessage.mainMsg?.level === 1 ? `warning` : warningMessage.mainMsg?.level === 2 ? `error` : ``}
                    showIcon
                    icon={warningMessage.mainMsg?.level === 0 ? <InfoCircleFilled /> : warningMessage.mainMsg?.level === 1 ? <ExclamationCircleFilled /> : warningMessage.mainMsg?.level === 2 ? <CloseCircleFilled /> : ``}
                    message={
                      <Marquee pauseOnHover gradient={false}>
                        <div
                          className='pointer'
                          onClick={async () => {
                            let war = warningMessage
                            war.mainMsg = {}
                            war.isOpen = true
                            war.isRead = true
                            setWarningMessage({ ...war })
                          }}
                        >
                          {warningMessage.mainMsg?.message_zh}
                        </div>
                      </Marquee>
                    }
                  ></Alert>
                </div>
              }

              {/* right */}
              <div className='flex jcc align_center'>
                {/* 无人机是否链接 */}
                <>
                  <img
                    className="marL12"
                    draggable='false'
                    alt='无人机'
                    src={airportData?.mode_code !== 14 ? t_wrj : f_wrj}
                  />
                </>

                {/* 当前网络 WiFi */}
                <>
                  {/* <img draggable='false'
            className="marL12"
            alt='WiFi'
            src={
              headStatusBar.wifi === 1
                ? wifi90
                : headStatusBar.wifi === 2
                  ? wifi60
                  : headStatusBar.wifi === 3
                    ? wifi30
                    : headStatusBar.wifi === 4
                      ? wifi0
                      : headStatusBar.wifi === 5
                        ? wifi_close
                        : wifi_none
            }
          /> */}
                </>

                {/* SDR信号 */}
                <>
                  <img
                    className="marL12"
                    // style={{ display: airportData?.wireless_link_sdr_link_state ? `` : `none` }}
                    draggable='false'
                    alt='SDR'
                    src={
                      airportData?.wireless_link_sdr_quality === 0 ? sdr0 :
                        airportData?.wireless_link_sdr_quality === 1 ? sdr15 :
                          airportData?.wireless_link_sdr_quality === 2 ? sdr35 :
                            airportData?.wireless_link_sdr_quality === 3 ? sdr55 :
                              airportData?.wireless_link_sdr_quality === 4 ? sdr75 : sdr95
                    }
                  />
                </>

                {/* 网络 1:4G| 2:以太网 */}
                <>
                  {
                    airportData?.network_state_type === 1//4G
                      ? (
                        <>
                          <Tooltip title={`${airportData?.network_state_rate}KB/s`}>
                            <img
                              className="marL12"
                              style={{ display: airportData?.wireless_link_4g_link_state ? `` : `none` }}
                              draggable='false'
                              alt='4g'
                              src={
                                airportData?.wireless_link_4g_gnd_quality === 0 ? cell0 :
                                  airportData?.wireless_link_4g_gnd_quality === 1 ? cell15 :
                                    airportData?.wireless_link_4g_gnd_quality === 2 ? cell35 :
                                      airportData?.wireless_link_4g_gnd_quality === 3 ? cell55 :
                                        airportData?.wireless_link_4g_gnd_quality === 4 ? cell75 : cell95
                              }
                            />
                          </Tooltip>
                        </>
                      )
                      : airportData?.network_state_type === 2//以太网
                        ? (
                          <>
                            <Tooltip title={`${airportData?.network_state_rate}KB/s`}>
                              <img
                                style={{ display: airportData?.network_state_type === 2 ? `` : `none` }}
                                className="marL12"
                                draggable='false'
                                alt='以太网'
                                src={Ethernet}
                              />
                            </Tooltip>
                          </>
                        )
                        : <></>
                  }
                </>

                {/* 当前电量 */}
                <>
                  <Tooltip title={airportData?.drone_charge_state_state ? `充电中(${airportData?.drone_charge_state_capacity_percent}%)···` : `${airportData?.drone_charge_state_capacity_percent}%`}>
                    <div className='marL12'>
                      <img
                        className=""
                        draggable='false'
                        alt='电量'
                        src={
                          airportData?.drone_charge_state_state
                            ? dl_charge
                            : airportData?.drone_charge_state_capacity_percent < 11
                              ? dl0
                              : airportData?.drone_charge_state_capacity_percent < 26
                                ? dl25
                                : airportData?.drone_charge_state_capacity_percent < 51
                                  ? dl50
                                  : airportData?.drone_charge_state_capacity_percent < 76
                                    ? dl75
                                    : airportData?.drone_charge_state_capacity_percent < 101
                                      ? dl100
                                      : dl_charge
                        }
                      />
                    </div>
                  </Tooltip>
                </>

                {/* 机场信息 */}
                <>
                  <img
                    className='pointer marL12'
                    draggable='false'
                    alt='机场'
                    src={t_jc}
                    onClick={() => {
                      let glo = globalStatus
                      glo.isOpenSeeAirportInfo = !globalStatus.isOpenSeeAirportInfo
                      setGlobalStatus({ ...glo })
                    }}
                  />
                </>

                {/* 机场详细信息 */}
                <>
                  {
                    globalStatus.isOpenSeeAirportInfo && JSON.stringify(airportData) !== '{}' &&
                    <div className='pos_abs pdR16 flex_col' style={{ top: 40, right: 0, }}>
                      <div
                        className='pos_abs w224 radius8 pd8 pos_rel'
                        style={{
                          top: '0', right: '0',
                          backgroundColor: 'rgba(0,0,0,0.7)',
                        }}>
                        <div>{airportData?.sn || `机场信息`} </div>
                        <Row>
                          <Col span={12} className='flex align_center'>
                            <span className="marR8">
                              <img draggable='false' src={rtk} alt='rtk' />
                            </span>
                            <span>
                              {airportData?.position_state_rtk_number}
                            </span>
                          </Col>

                          <Col span={12} className='flex align_center'>
                            <span className="marR8">
                              <img draggable='false' src={gps} alt='gps数量' />
                            </span>
                            <span>
                              {airportData?.position_state_gps_number}
                            </span>
                          </Col>


                          <Col span={12} className='flex align_center'>
                            <span className="marR8">
                              <img className='h20 w20' draggable='false' src={wd} alt='温度' />
                            </span>
                            <span>{airportData?.temperature}℃</span>
                          </Col>

                          <Col span={12} className='flex align_center'>
                            <span className="marR8 ">
                              <img className='h20 w20' draggable='false' src={sd} alt='湿度' />
                            </span>
                            <span>{airportData?.humidity}</span>
                          </Col>


                          <Col span={12} className='flex align_center'>
                            <span className="marR8">
                              <img draggable='false' src={dj} alt='东经' />
                            </span>
                            <span>{Number(airportData?.latitude || 0).toFixed(6)}</span>
                          </Col>

                          <Col span={12} className='flex align_center'>
                            <span className="marR8">
                              <img draggable='false' src={bw} alt='北纬' />
                            </span>
                            <span>{Number(airportData?.longitude || 0).toFixed(6)}</span>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  }
                </>
              </div>
            </div>
          </div>
        }
      </>

      {/* 左上角 切换地图图层 */}
      <>
        {
          false &&
          <div className="pos_abs radius8 pointer" style={{ top: '48px', left: '24px', background: '#1F1F1F' }}
          >
            {/* <BlockOutlined className="w16 h16 mar12" style={{ color: 'white' }} /> */}
            <Button icon={<BlockOutlined />} onClick={() => { setOpacity(!opacity) }} />
          </div>
        }
      </>

      {/* 左侧 详细警告信息 */}
      <>
        <div className="pos_abs radius8 w300"
          style={{
            top: '48px', left: '16px',
            background: 'rgba(0,0,0,0.7)',
            display: warningMessage.isOpen ? `` : `none`,
            zIndex: 1,
          }}
        >
          <div className='flex jcr mar4'>
            <CloseOutlined
              className='opa45 pointer'
              onClick={async () => {
                let war = warningMessage
                war.isOpen = false
                war.isRead = false
                setWarningMessage({ ...war })
                let res = await airportHealthInfoReadAPI({
                  access_token: token,
                  ids: warningMessage.ids.join(',')
                })
                if (res.ret !== 200) { message.warning(res.msg || '只读失败') }
                getAirporintInfo()
              }}
            />
          </div>
          <div className='marTB12 marRL16 hidden'
            style={{ maxHeight: 'calc(100vh - 616px)', overflowY: 'auto' }}
          >
            {/* 无人机 */}
            <div
              style={{ borderBottom: '1px solid ' + colorBorderSecondary, display: warningMessage.UAVMsg.length > 0 ? `` : `none` }}
            >
              <Tag className='marB8'>无人机</Tag>
              <div className='marB8'>
                {
                  // false &&
                  (warningMessage.UAVMsg || []).map((res, index) => {
                    return (
                      <div className='flex jcsb' key={index}>
                        <div
                          className='marR8'
                          style={{
                            wordBreak: 'break-all',
                            color:
                              res.level === 0
                                ? `rgb(82,196,26)`
                                : res.level === 1
                                  ? `#D89614`
                                  : res.level === 2
                                    ? `#DC4446`
                                    : ``,
                          }}
                        >
                          {res.message_zh}
                        </div>

                        <div className='w55 opa45'>{res.time}</div>
                      </div>
                    )
                  })
                }

              </div>
            </div>

            {/* 机场 */}
            <div
              className='marTB8'
              style={{ display: warningMessage.airportMsg.length > 0 ? `` : `none` }}
            >
              <Tag className='marB8'>机场</Tag>
              <div className='marB8'>
                {
                  (warningMessage.airportMsg || []).map((res, index) => {
                    return (
                      <div className='flex jcsb' key={index}>
                        <div
                          className='marR8'
                          style={{
                            wordBreak: 'break-all',
                            color:
                              res.level === 0
                                ? `rgb(82,196,26)`
                                : res.level === 1
                                  ? `#D89614`
                                  : res.level === 2
                                    ? `#DC4446`
                                    : ``,
                          }}
                        >
                          {res.message_zh}
                        </div>

                        <div className='w55 opa45'>{res.time}</div>
                      </div>
                    )
                  })
                }
              </div>

            </div>
          </div>
        </div>
      </>

      {/* 右下  信息栏  */}
      <>
        {
          JSON.stringify(UAVData) !== '{}' &&
          <div
            className='pos_abs flex_row radius8'
            style={{ bottom: '16px', right: '16px', }}
          >
            {/* 右下  信息栏  左上信息 */}
            <div className='marR16'>
              {
                (globalStatus.isOpenSeeUAVInfo && JSON.stringify(UAVData) !== '{}') &&
                <div
                  className=' radius8 pd8 flex_col'
                  style={{
                    // top: '-210px', right: '332px',
                    backgroundColor: 'rgba(0,0,0,0.7)',
                  }}
                >
                  {/* 无人机编号 */}
                  <div>{UAVData?.sn || `无人机信息`}</div>
                  <div className='flex_row flex_shrink0'>
                    <div className='flex_auto marR16 flex_shrink0'>
                      {/* rtk数量 */}
                      <div>
                        <span className="marR8">
                          <Tooltip title='rtk数量'><img draggable='false' src={rtk} alt='rtk' /></Tooltip>
                        </span>
                        <span>
                          {UAVData?.position_state_rtk_number || 0}
                        </span>
                      </div>
                      {/* 东经 */}
                      <div>
                        <span className="marR8">
                          <Tooltip title='东经'><img draggable='false' src={dj} alt='dj' /></Tooltip>
                        </span>
                        <span>{Number(UAVData?.latitude || 0).toFixed(6)}</span>
                      </div>
                      {/* 相对起飞点高度 */}
                      <div>
                        <span className="marR8">
                          <Tooltip title='相对起飞点高度'><img draggable='false' src={xdqfgd} alt='xdqfgd' /></Tooltip>
                        </span>
                        <span>{Number(UAVData?.elevation || 0).toFixed(2)} m</span>
                      </div>
                      {/* 水平速度 */}
                      <div>
                        <span className="marR8">
                          <Tooltip title='水平速度'><img draggable='false' src={spsd} alt='spsd' /></Tooltip>
                        </span>
                        <span>{Number(UAVData?.horizontal_speed || 0).toFixed(1)}</span>
                      </div>
                    </div>

                    <div className='flex_auto marR16 flex_shrink0'>
                      {/* GPS数量 */}
                      <div>
                        <span className="marR8">
                          <Tooltip title='GPS数量'><img draggable='false' src={gps} alt='gps' /></Tooltip>
                        </span>
                        <span>
                          {UAVData?.position_state_gps_number || 0}
                        </span>
                      </div>
                      {/* 北纬 */}
                      <div>
                        <span className="marR8">
                          <Tooltip title='北纬'><img draggable='false' src={bw} alt='bw' /></Tooltip>
                        </span>
                        <span>{Number(UAVData?.longitude || 0).toFixed(6)}</span>
                      </div>
                      {/* 海拔 */}
                      <div>
                        <span className="marR8">
                          <Tooltip title='海拔'><img draggable='false' src={hbgd} alt='hbgd' /></Tooltip>
                        </span>
                        <span>{Number(UAVData?.height || 0).toFixed(1)}</span>
                        {/* <span>N/A</span> */}
                      </div>
                      {/* 垂直速度 */}
                      <div>
                        <span className="marR8">
                          <Tooltip title='垂直速度'><img draggable='false' src={czsd} alt='czsd' /></Tooltip>
                        </span>
                        <span>{Number(UAVData?.vertical_speed || 0).toFixed(1)}</span>
                      </div>
                    </div>

                    <div className='flex_col flex_shrink0'>
                      <div className='flex_auto'></div>
                      <div>
                        <span className="marR8">
                          <Tooltip title='无人机离机场距离'><img draggable='false' src={jcjl} alt='无人机离机场距离' /></Tooltip>
                        </span>
                        <span>
                          {
                            UAVData?.longitude && airportData?.longitude
                              ? distance([UAVData?.longitude, UAVData?.latitude], [airportData?.longitude, airportData?.latitude]).toFixed(1)
                              : 0.0
                          } m
                        </span>
                      </div>
                    </div>
                  </div>

                  <div></div>
                </div>
              }
            </div>

            <div className='flex_col'>
              {/* 无人机飞行时数据 */}
              <div className='w300 pdT16 pdRL24 pdB24 radius8' style={{ backgroundColor: '#1F1F1F' }}>
                <div className='flex_col' >
                  {/* 第一层 */}
                  <div className='flex jcsb marB8 h80'>
                    {/* 无人机详细信息 */}
                    <div className=''>
                      <InfoCircleOutlined
                        onClick={() => {
                          let glo = globalStatus
                          glo.isOpenSeeUAVInfo = !glo.isOpenSeeUAVInfo
                          setGlobalStatus({ ...glo })
                        }}
                      />
                    </div>

                    {/* 飞行速度 */}
                    <div className='flex align_end'>
                      <div className='fs99 lh80 flex align_center'>
                        <b>
                          {
                            UAVData?.horizontal_speed
                              ? Number(UAVData?.horizontal_speed || 0).toFixed(1)
                              : Number(UAVData?.vertical_speed || 0).toFixed(1)
                          }
                        </b>
                      </div>
                      <div className='flex jcc marL8 align_center'><img draggable='false' src={uav_ms} alt='M/S' /></div>
                    </div>
                  </div>

                  {/* 第二层 */}
                  <div className='flex marTB8 jcsb align_center'>

                    {/* 上视规避 */}
                    <img className='w25 h25' draggable='false' src={UAVData?.obstacle_avoidance_upside ? uav_t_ssbz : uav_f_ssbz} alt='上视规避' />

                    {/* 水平规避 */}
                    <img className='w25 h25' draggable='false' src={UAVData?.obstacle_avoidance_horizon ? uav_t_spbz : uav_f_spbz} alt='水平规避' />

                    {/* 下视规避 */}
                    <img className='w25 h25' draggable='false' src={UAVData?.obstacle_avoidance_downside ? uav_t_xsbz : uav_f_xsbz} alt='下视规避' />

                    {/* 电量 */}
                    <div className='w67 flex jcr align_center'>
                      <span
                        className='fs20 lh25'
                        style={{
                          color: UAVData?.battery_capacity_percent > 30 ? '#25CB55' : '#E50019', opacity: '0.75'
                        }}
                      >
                        <b>{`${UAVData?.battery_capacity_percent || 0}%`}</b>
                      </span>
                      <img draggable='false' src={UAVData?.battery_capacity_percent > 30 ? uav_t_dl : uav_f_dl} alt='uav_dl' />
                    </div>
                  </div>

                  {/* 第三层 */}
                  <div className='flex jcsb h25'>
                    {/* 相对起飞高度 */}
                    <div className='flex jcc align_center'>
                      <img draggable='false' className='marR4 w32 h25' src={uav_xdqfdgd} alt='uav_xdqfdgd' />
                      <span className=' fs20 lh25'>
                        <b>
                          {`${Number(UAVData?.elevation || 0).toFixed(1)} m`}
                        </b>
                      </span>
                    </div>
                    {/* 相对机场距离 */}
                    <div className='flex jcc align_center'>
                      <img draggable='false' className='marR4 lh25' src={uav_xdjcgd} alt='uav_xdjcgd' />
                      <span className='fs20 lh25'>
                        <b>
                          {
                            UAVData?.longitude && UAVData?.latitude && airportData?.longitude && airportData?.latitude
                              ? distance([UAVData?.longitude || 0, UAVData?.latitude || 0], [airportData?.longitude || 0, airportData?.latitude || 0]).toFixed(1)
                              : 0.0
                          } m
                        </b>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* 无人机返航 */}
              <>
                {
                  status[UAVData?.mode_code] && limitsAuthority.current?.indexOf(168) > -1 &&
                  <div
                    className='marT16 radius8 pdTB16 pdRL24'
                    style={{ backgroundColor: '#1F1F1F' }}
                  >
                    {/* 返航 */}
                    <Popconfirm
                      open={[3, 5].indexOf(UAVData.mode_code) > -1 && !globalStatus.isReturnFlight && globalStatus.isShowPopconfirm}
                      title="返航"
                      description={
                        <div>
                          <span>
                            结束当前飞行任务，将无人机返航？
                          </span>
                          <div style={{ color: '#DC4446' }}>
                            注：执行返航后，后续任务将不再执行，
                            <div>亦不可取消返航</div>
                          </div>
                        </div>
                      }
                      onConfirm={async () => {
                        let glo = globalStatus
                        glo.isReturnFlight = true
                        setGlobalStatus({ ...glo })
                        let res = await returnHome({ access_token: token, dock_id: dockIdRef.current, })
                        if (res.ret !== 200) {
                          message.warning(res.msg || '数据跑丢了')
                          glo.isReturnFlight = false
                          setGlobalStatus({ ...glo })
                          return
                        }
                        glo.isShowPopconfirm = false
                        setGlobalStatus({ ...glo })
                      }}
                      onCancel={() => {
                        let glo = globalStatus
                        glo.isShowPopconfirm = false
                        setGlobalStatus({ ...glo })
                      }}
                      okText="确定返航"
                      cancelText="取消返航"
                    >
                      <Button
                        style={{ width: '252px' }}
                        icon={globalStatus.isReturnFlight ? <LoadingOutlined /> : <VerticalAlignBottomOutlined />}
                        disabled={!([3, 5].indexOf(UAVData.mode_code) > -1)}
                        onClick={() => {
                          if (!globalStatus.isReturnFlight) {
                            let glo = globalStatus
                            glo.isShowPopconfirm = true
                            setGlobalStatus({ ...glo })
                          }
                        }}
                      >
                        {globalStatus.isReturnFlight ? `返航中` : `返航`}
                      </Button>
                    </Popconfirm>
                  </div>
                }
              </>
            </div>

          </div>
        }
      </>

      {/* 下中 无人机飞行状态 */}
      <>
        {
          status[UAVData?.mode_code] &&
          <div
            className='pos_abs radius8 pdTB16 pdRL24 w300 h57'
            style={{ backgroundColor: '#1F1F1F', bottom: '16px', left: 'calc(50% - 150px)' }}
          >
            <div className='fs20 fw400 lh25'>{status[UAVData?.mode_code]}</div>
          </div>
        }
      </>
      {/* </div > */}

      {/* 左下角  视频栏 */}
      <>
        {
          <div
            className='pos_abs radius8 mar16 marB24'
            style={{ bottom: '24px', left: '24px', }}
          >
            <div className='flex jcsb align_center'>
              <Segmented
                value={videoType}
                options={typeList}
                onChange={(e) => {
                  setVideoType(e)
                  liveUrl.current = ''
                  setLiveUrlState('')
                  setLoadingAll(true)
                  setTimeout(() => {
                    liveAddress(e)
                  }, 1000);
                }}
              />

              {/* 镜头类型 */}
              {/* <Segmented
                disabled={!UAVLiveStreamStart}
                value={shotType}
                options={[
                  { value: 'wide', label: '广角', idx: 1, },
                  { value: 'zoom', label: '变焦', idx: 2, },
                  { value: 'ir', label: '红外', idx: 3, },
                ]}
                onChange={async (e) => {
                  let obj = {
                    access_token: token,
                    dock_id: dockIdRef.current,
                    type: e
                  }
                  let res = await changeLensAPI(obj)
                  if (res.ret !== 200) { message.warning(res.msg || '切换镜头失败'); return }
                  message.success(res.msg || `切换到${value === 'W' ? `广角` : `红外`}成功`)
                  setShotType(e)
                }}
              /> */}
            </div>

            {/* 视频播放器 容器 */}
            <div className='w300 h225 marT8 radius8 hidden flex jcc align_center'
              style={{ backgroundColor: '#1D1D1D', }}
            >
              <Spin spinning={loadingAll}>
                {/* DOCK */}
                {
                  (videoType === 'dock' || videoType === 'cam') && !loadingAll &&
                  <div
                    className='w300 h225 radius8'
                    style={{ display: (videoType === 'dock' || videoType === 'cam') && !loadingAll ? `` : `none` }}
                  >
                    {
                      (videoType === 'dock' && liveUrl.current) || (videoType === 'cam' && liveUrl.current && JSON.stringify(UAVData) !== '{}')//是否存在直播地址
                        ? (
                          <FlvVideo
                            type={videoType}
                            liveUrl={liveUrl.current}
                            liveVideoReturn={returnData}
                          />
                        )
                        : (
                          <div className='wid100 hei100 flex_col jcc align_center'>
                            <>{/* 警告图标 */}
                              <img
                                src={videoType === 'cam' ? airportWarning : warning}
                                alt='警告'
                                style={{
                                  height: videoType === 'cam' ? '38px' : '80px',
                                  width: videoType === 'cam' ? '38px' : '80px',
                                  marginBottom: videoType === 'cam' ? '10px' : '',
                                }}
                              />
                            </>

                            <>{/* 错误主体文字 */}
                              <div
                                className={`col_main_text ${videoType === 'cam' ? 'fs14 lh22 fw400 opa45' : 'fs24 opa88'}`}
                              >
                                直播暂未开启
                              </div>
                            </>

                            <>{/* 开启推流 */}
                              <Button
                                id='startVideo'
                                type='primary'
                                disabled={videoType === 'cam' && JSON.stringify(UAVData) === '{}'}
                                onClick={() => { pushFlow() }}
                              >
                                开启并观看
                              </Button>
                            </>
                          </div>
                        )
                    }

                    <>{/* 节流提示 */}
                      {
                        videoType === 'dock' && openInfo !== 0 &&
                        <div
                          className='pos_abs flex jcl wid100 pd8 opa85'
                          style={{ top: 0, left: 0, backgroundColor: 'rgba(0,0,0,0.6)' }}
                        >
                          <>{/* 直播剩余时长  提示 */}
                            {openInfo === 1 &&
                              <div>
                                {`监测到屏幕已有 5 分钟无任何操作，如果你还在观看请动动鼠标，否则 ${(20 - timeNumber)} 秒后将会关闭该直播，以节省网络资源。`}
                              </div>
                            }
                          </>
                          <>
                            {
                              openInfo === 2 && videoType === 'dock' &&
                              <div>
                                {`因长时间无任何操作，已关闭该直播`}
                              </div>
                            }
                          </>
                        </div>

                      }

                    </>

                  </div>
                }
              </Spin>
            </div>
          </div>
        }
      </>

      <>{/* 鼠标指向显示信息 */}
        <div id='div_info' className='pos_abs radius8'
          style={{
            zIndex: 20,
            left: divLeft - 230,
            top: divTop - 120,
            padding: '6px 8px',
            color: 'white',
            fontSize: '14px',
            background: '#000000bf',
            display: floating.visible ? '' : 'none',
          }}
        >
          {floating.title}
        </div>
      </>
    </>
  )
}
export default VideoPatrolMonitor;